import { render, staticRenderFns } from "./RadioAnswer.vue?vue&type=template&id=486e7f5f&scoped=true"
import script from "./RadioAnswer.vue?vue&type=script&lang=js"
export * from "./RadioAnswer.vue?vue&type=script&lang=js"
import style0 from "./RadioAnswer.vue?vue&type=style&index=0&id=486e7f5f&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e7f5f",
  null
  
)

export default component.exports